<template>
  <div>
    <SysInputFormatadorValor
      v-model="produto.preco_custo"
      ref="inputRef"
      :max-digitos="configuracoes.CASAS_DECIMAIS_CARRINHO"
      remover-valor-irrelevante
      centralizar
      class="input-regular font-resp"
      @keydown.enter="editarPrecoCustoProduto()"
      @focus="$event.target.select()"
      @blur="editarPrecoCustoProduto()"
      @click.stop
    >
      <template #prefixo>
        <span v-if="prefix !== 'ST'">{{ prefix }}</span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on, attrs }">
            <span class="cursor-help" v-bind="attrs" v-on="on">{{ prefix }}</span>
          </template>
          <span v-if="prefix === 'ST'">Sem tabela</span>
        </v-tooltip>
      </template>
      <template #sufixo>{{ suffix }}</template>
    </SysInputFormatadorValor>
  </div>
</template>

<script>
import SysInputFormatadorValor from "@/components/utils/InputFormatadorDeValor.vue";
import {mapGetters} from "vuex";
import {atualizarProdutoNoCarrinho} from "@/api/compraPorProdutosGerais/Carrinho";
import {logout} from "@/helpers";
import api from "@/api/api";

export default {
  name: "PrecoCustoProduto",
  props: {
    produto: Object,
    pedido_selecionado: Object,
    prefix: String,
    suffix: String
  },
  components: {
    SysInputFormatadorValor
  },
  data: () => ({
    edicao_salva: true
  }),
  computed: {
    ...mapGetters({
      configuracoes: "configuracoes/carrinho",
    })
  },
  watch: {
    'produto.preco_custo': function () {
      this.edicao_salva = false;
    }
  },
  methods: {
    editarPrecoCustoProduto() {
      if (this.produto.preco_custo <= 0) {
        return;
      }

      if (this.edicao_salva) {
        return;
      }

      const parametros = {
        idpedido: this.pedido_selecionado.idpedido,
        idproduto: this.produto.idproduto,
        preco_custo: this.getPrecoCustoEmbalagemMinimo()
      };

      api.put('compras/produtos/carrinho/produtos', parametros, { silentLoading: true })
        .then(() => {
          this.edicao_salva = true;
          this.produto.exportado = 'N';
        })
        .catch(logout)
    },
    getPrecoCustoEmbalagemMinimo() {
      if (this.pedido_selecionado.emb_master === "N") {
        return Number(this.produto.preco_custo);
      }

      if (this.produto.tipo_fator_conversao === 'D') {
        return Number(this.produto.preco_custo) / Number(this.produto.multiplo_compra);
      }

      return Number(this.produto.preco_custo) * Number(this.produto.multiplo_compra);
    },
    focus() {
      this.$refs.inputRef.focus()
    }
  }
}
</script>

<style scoped>

</style>
